import { render, staticRenderFns } from "./RecommendationDefaultList.vue?vue&type=template&id=d85547d4&lang=pug"
import script from "./RecommendationDefaultList.vue?vue&type=script&lang=js"
export * from "./RecommendationDefaultList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports